"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, type ImgHTMLAttributes } from "react";
import { ImageOff } from "lucide-react";

/**
 * <img> yang berhenti mencoba lagi setelah gagal sekali dan menampilkan
 * placeholder netral — bukan ikon rusak bawaan browser, dan bukan retry ke
 * URL lain (itu yang memicu error jaringan berulang di console kalau host
 * asal memang sudah mati/dihapus). Dipakai HANYA di titik yang src-nya sudah
 * dipastikan ada; caller tetap menangani sendiri kasus "belum ada gambar
 * sama sekali" (biasanya fallback inisial/ikon sebelum <SafeImage> dirender).
 */
export default function SafeImage(t0) {
  const $ = _c(18);
  let alt;
  let className;
  let onError;
  let rest;
  let src;
  if ($[0] !== t0) {
    ({
      src,
      alt,
      className,
      onError,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = onError;
    $[4] = rest;
    $[5] = src;
  } else {
    alt = $[1];
    className = $[2];
    onError = $[3];
    rest = $[4];
    src = $[5];
  }
  const [failed, setFailed] = useState(false);
  if (failed) {
    const t1 = `flex items-center justify-center bg-gray-100 text-gray-300 dark:bg-slate-800 dark:text-slate-600 ${className ?? ""}`;
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ImageOff className="h-1/3 w-1/3 max-h-8 max-w-8 opacity-70" />;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== alt || $[8] !== t1) {
      t3 = <div className={t1} role="img" aria-label={alt}>{t2}</div>;
      $[7] = alt;
      $[8] = t1;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t1;
  if ($[10] !== onError) {
    t1 = e => {
      setFailed(true);
      onError?.(e);
    };
    $[10] = onError;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== alt || $[13] !== className || $[14] !== rest || $[15] !== src || $[16] !== t1) {
    t2 = <img src={src} alt={alt} className={className} onError={t1} {...rest} />;
    $[12] = alt;
    $[13] = className;
    $[14] = rest;
    $[15] = src;
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
}